/* eslint-disable no-param-reassign */
import _ from 'lodash';
import pdfStyle from '@/services/print/pdfStyle.config';
import { loadSvgFile } from '@/services/print/svghelpers';

const { baseFont } = pdfStyle;

function applyStyles(styles, selection) {
    if (!selection) {
        return selection;
    }
    const { fill, stroke, font, selectors } = styles;
    if (fill) {
        selection.attr('fill', styles.fill);
    }
    if (stroke) {
        selection.attr('stroke', styles.stroke);
    }
    if (font) {
        selection.style('font-size', font.size)
            .style('font-family', font.family);
        // Bold not working yet
        // .style('font-weight', font.type);
        // TODO: Support for italics
    }
    if (selectors) {
        _.forIn(selectors, (selectorStyles, selector) => applyStyles(selectorStyles, selection.selectAll(selector)));
    }
    return selection;
}

function styleSvg(svg, { w = 100, h = 100, styles, font = baseFont, onload, preserveAspectRatio = true }) {
    const d3Svg = d3.select(svg);

    // Use the font of the element on the svg itself
    // Fonts for individual selectors can be set in styles.
    d3Svg.attr('font-family', font.family)
        .attr('font-size', font.size)
        // Italics not supported yet
        .attr('font-style', 'normal');
    // Bold not working yet either

    // Replaces any custom fonts, eliminate italics for all text elements
    d3Svg.selectAll('text')
        .attr('font-family', font.family)
        .attr('font-style', 'normal');

    const originalWidth = d3Svg.attr('width') || w;
    const originalHeight = d3Svg.attr('height') || h;
    d3Svg.attr('width', w).attr('height', h);
    if (!d3Svg.attr('viewBox')) {
        d3Svg.attr('viewBox', `0 0 ${originalWidth} ${originalHeight}`);
    }
    if (!preserveAspectRatio) {
        d3Svg.attr('preserveAspectRatio', 'none');
    }
    if (styles) {
        applyStyles(styles, d3Svg);
    }


    if (onload) {
        onload(d3Svg);
    }
    return d3Svg.node();
}

async function loadSvg(content = {}) {
    const { src, svg } = content;
    let svgData = svg;
    if (src) {
        svgData = await loadSvgFile(content);
    }
    if (!svgData) {
        return null;
    }
    svgData = styleSvg(svgData, content);
    // svgData = svgData.cloneNode(true);

    content.svgData = svgData;
    return svgData;
}

async function loadImage(content) {
    // console.log('Loading image from content:', content);
    // eslint-disable-next-line
    const url = require(`@/assets/print/images/${content.src}`);
    if (url.endsWith('.svg')) {
        return loadSvg(content);
    }
    // console.log('URL: ', url);
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            content.img = img;
            resolve(content);
        };
        img.onerror = reject;
        img.src = url;
    });
}

async function loadContent(content, asyncLoaders = []) {
    if (content.src) {
        asyncLoaders.push(loadImage(content));
    }
    // NOTE: svgs can be loaded as images above as well.
    // Use .svg only if loading a documentElement directly:
    if (content.svg) {
        // console.log('LOADING actual svg:', typeof content.svg, content.svg);
        asyncLoaders.push(loadSvg(content));
    }

    _.forEach(content, (node) => {
        // if (node === undefined || node === null) {
        //     console.warn('TODO: No nulls allowed?', content, key);
        // }
        if (node && node.contentType) {
            loadContent(node, asyncLoaders);
        }
    });
    await Promise.all(asyncLoaders);
    return content;
}

export default loadContent;
